if (!customElements.get('product-bulk-add')) {
  // Mismo formato que el filtro money de Liquid, para que el total del boton
  // se vea igual que los precios de la ficha.
  const formatMoney = (centavos, formato) => {
    const numero = (decimales, miles = ',', decimal = '.') => {
      const [entero, resto] = (centavos / 100).toFixed(decimales).split('.');
      return entero.replace(/\B(?=(\d{3})+(?!\d))/g, miles) + (resto ? decimal + resto : '');
    };
    const valores = {
      amount: () => numero(2),
      amount_no_decimals: () => numero(0),
      amount_with_comma_separator: () => numero(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => numero(0, '.', ','),
      amount_with_apostrophe_separator: () => numero(2, "'", '.'),
      amount_no_decimals_with_space_separator: () => numero(0, ' ', ','),
      amount_with_space_separator: () => numero(2, ' ', ','),
      amount_with_period_and_space_separator: () => numero(2, ' ', '.'),
    };
    return (formato || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, clave) => (valores[clave] || valores.amount)());
  };

  customElements.define(
    'product-bulk-add',
    class ProductBulkAdd extends HTMLElement {
      connectedCallback() {
        this.filas = Array.from(this.querySelectorAll('.pb-flavor[data-variant]'));
        if (!this.filas.length) return;

        this.iniciales = this.filas.map((fila) => this.cantidad(fila));

        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));

        // Los botones de agregar viven fuera: la ficha y la barra fija.
        document.addEventListener('click', this.onSubmitClick, true);

        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onSubmitClick, true);
      }

      input(fila) {
        return fila.querySelector('.pb-qty__input');
      }

      cantidad(fila) {
        return Math.max(0, parseInt(this.input(fila).value, 10) || 0);
      }

      tope(fila) {
        const max = parseInt(this.input(fila).max, 10);
        return Number.isNaN(max) ? Infinity : max;
      }

      get total() {
        return this.filas.reduce((suma, fila) => suma + this.cantidad(fila), 0);
      }

      get monto() {
        return this.filas.reduce((suma, fila) => suma + this.cantidad(fila) * (parseInt(fila.dataset.price, 10) || 0), 0);
      }

      onClick(event) {
        const paso = event.target.closest('.pb-qty__step');
        if (!paso) return;

        const fila = paso.closest('.pb-flavor');
        this.fijar(fila, this.cantidad(fila) + parseInt(paso.dataset.step, 10));
      }

      onChange(event) {
        if (!event.target.classList.contains('pb-qty__input')) return;

        const fila = event.target.closest('.pb-flavor');
        this.fijar(fila, this.cantidad(fila));
      }

      fijar(fila, valor) {
        this.input(fila).value = Math.max(0, Math.min(valor, this.tope(fila)));
        this.refresh();
      }

      refresh() {
        const total = this.total;

        const contador = this.querySelector('[data-count]');
        if (contador) contador.textContent = total;
        const palabra = this.querySelector('[data-count-word]');
        if (palabra) palabra.textContent = total === 1 ? this.dataset.unit : this.dataset.units;

        this.filas.forEach((fila) => {
          const cantidad = this.cantidad(fila);
          const menos = fila.querySelector('[data-step="-1"]');
          const mas = fila.querySelector('[data-step="1"]');
          if (menos) menos.disabled = cantidad <= 0;
          if (mas) mas.disabled = cantidad >= this.tope(fila);
        });

        if (total > 0) this.ocultarAviso();
        this.paintButton();
      }

      // El boton del tema muestra el precio de lo que se agregara.
      paintButton() {
        const monto = this.monto;
        const etiqueta = monto > 0 ? `${this.dataset.addLabel} · ${formatMoney(monto, this.dataset.moneyFormat)}` : this.dataset.addLabel;

        document.querySelectorAll(`[form="${this.dataset.form}"], #${this.dataset.form} [type="submit"]`).forEach((boton) => {
          const span = boton.querySelector('span');
          if (span && !boton.closest('product-bulk-add')) span.textContent = etiqueta;
        });
      }

      mostrarAviso(texto) {
        const aviso = this.querySelector('.pack-options-notice');
        if (!aviso) return;

        const mensaje = aviso.querySelector('[data-notice]');
        if (mensaje) {
          mensaje.dataset.original ??= mensaje.textContent;
          mensaje.textContent = texto || mensaje.dataset.original;
        }

        aviso.removeAttribute('hidden');
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      ocultarAviso() {
        this.querySelector('.pack-options-notice')?.setAttribute('hidden', '');
      }

      onSubmitClick(event) {
        const boton = event.target.closest?.('button[type="submit"]');
        if (!boton || boton.closest('product-bulk-add')) return;

        const form = boton.form || document.getElementById(boton.getAttribute('form') || '');
        if (!form || form.getAttribute('id') !== this.dataset.form) return;

        // Todo lo elegido entra junto: el formulario del tema solo sabria
        // agregar una unidad de esta ficha.
        event.preventDefault();
        event.stopPropagation();

        const items = this.filas
          .map((fila) => ({ id: Number(fila.dataset.variant), quantity: this.cantidad(fila) }))
          .filter((item) => item.quantity > 0);

        if (!items.length) {
          this.mostrarAviso();
          return;
        }

        this.addToCart(boton, items);
      }

      async addToCart(boton, items) {
        const drawer = document.querySelector('cart-drawer');
        boton.classList.add('loading');
        boton.setAttribute('aria-disabled', 'true');

        try {
          if (window.packTiers) {
            await window.packTiers.agregar(items);
          } else {
            const respuesta = await fetch(`${window.routes.cart_add_url}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({
                items,
                sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
                sections_url: window.location.pathname,
              }),
            });

            const resultado = await respuesta.json();
            if (resultado.status) throw new Error(resultado.description || resultado.message);

            if (drawer) drawer.renderContents(resultado);
            else window.location.href = window.routes.cart_url;
          }

          this.reset();
        } catch (e) {
          // Cuando no alcanza, Shopify agrega lo que puede y explica por que.
          // Se limpia el selector para que otro clic no duplique lo que ya
          // entro, y el carrito se repinta sin abrirse para que el aviso se lea.
          this.reset();
          await this.repintarCarrito();
          this.mostrarAviso(e.message);
        } finally {
          boton.classList.remove('loading');
          boton.removeAttribute('aria-disabled');
        }
      }

      async repintarCarrito() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        try {
          const secciones = drawer.getSectionsToRender();
          const raiz = window.Shopify?.routes?.root || '/';
          const html = await fetch(`${raiz}?sections=${secciones.map((s) => s.id).join(',')}`).then((r) => r.json());

          secciones.forEach((seccion) => {
            const elemento = seccion.selector ? document.querySelector(seccion.selector) : document.getElementById(seccion.id);
            if (elemento && html[seccion.id]) elemento.innerHTML = drawer.getSectionInnerHTML(html[seccion.id], seccion.selector);
          });

          // El fondo oscuro es nuevo: hay que volver a enseñarle a cerrar.
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));

          const carrito = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
          drawer.classList.toggle('is-empty', carrito.item_count === 0);
        } catch (e) {
          // Si no se pudo repintar, el carrito se ve al recargar.
        }
      }

      reset() {
        this.filas.forEach((fila, i) => {
          this.input(fila).value = this.iniciales[i];
        });
        this.refresh();
      }
    }
  );
}
